export enum ECalendar {
	GOOGLE_CALENDAR = 'Google Calendar',
	OUTLOOK_CALENDAR = 'Outlook Calendar',
	IOS_CALENDAR = 'iOS Calendar',
	CALENDERLY = 'Calendarly',
	CAL_COM = 'Cal.com',
	GOHIGHLEVEL_CALENDAR = 'gohighlevel',
}
